import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import Spinner from "../components/Spinner";

const IfuPage = lazy(() => import("../pages/IfuPage"));
const PrivacyPolicyPage = lazy(() => import("../pages/PrivacyPolicyPage"));
const TermsOfUsePage = lazy(() => import("../pages/TermsOfUsePage"));
const AppWithProviders = lazy(() => import("../AppWithProviders"));

export default function AppRoutes() {
  return (
    <Suspense fallback={<div className="m-auto"><Spinner /></div>}>
      <Routes>
        {/* Public documents must not depend on auth resolution, tokens or device checks. */}
        <Route path="/ifu" element={<IfuPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
        <Route path="/terms-of-use" element={<TermsOfUsePage />} />
        <Route path="*" element={<AppWithProviders />} />
      </Routes>
    </Suspense>
  );
}
